import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Projects from './views/Projects.vue'
import Project from './views/Project.vue'
import Company from './views/Company.vue'
import Contacts from './views/Contacts.vue'
import Layout from './views/Layout.vue'

Vue.use(Router)

const router = new Router({
  scrollBehavior( to, from, savedPosition ) {
    return {
      x: 0,
      y: 0,
    }
  },

  mode: 'history',

  routes: [
    {
      path: '/',
      name: 'index',
      redirect: {
        name: 'home',
        params: {
          lang: 'en',
        },
      },
    },

    {
      path: '/:lang',
      component: Layout,
      props: true,
      name: 'lang',

      children: [
        {
          path: '/',
          name: 'home',
          component: Home,
          props: true,
        },
        {
          path: 'projects/:activeSection',
          name: 'projects',
          component: Projects,
          props: true,
        },
        {
          path: 'project/:projectSlug',
          name: 'project',
          component: Project,
          props: true,
        },
        {
          path: 'company',
          name: 'company',
          component: Company
        },
        {
          path: 'contacts',
          name: 'contacts',
          component: Contacts
        },
      ],
    },
  ]
})

router.beforeEach((to, from, next) => {
  const { lang } = to.params;

  if (['en'].includes(lang)) {
    Vue.i18n.set(lang);
    // router.options.base = '/' + lang;
    return next();
  }

  next('/');
});

export default router;